export default "/images/vendor/@coreui/icons/svg/flag/cif-er.svg?5d1ac006a0580e179fb09dd44b5974c5";